/* eslint-disable prefer-destructuring */
// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"MyElPgBdL6-GNO8U6yEkG"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://586b9fd70e3941c5bd117119a7ced6c3@o1180669.ingest.us.sentry.io/4504061865426944',
  environment: window.env?.ENV,
  ignoreErrors: ['AbortError'],
  integrations: [
    Sentry.replayIntegration({
      maxReplayDuration: 3600000,
    }),
    Sentry.replayCanvasIntegration(),
  ],
  replaysOnErrorSampleRate: window.env?.SENTRY_REPLAY_SAMPLE_RATE,
  replaysSessionSampleRate: 0,
  sampleRate: window.env?.SENTRY_SAMPLE_RATE,
  tracesSampleRate: 0,
});
